import React from "react";
import { connect } from "react-redux";

import { Dropdown } from "lib/components/vendor";
import AppSettings from "lib/services/AppSettings";

export default class TagsInput extends React.PureComponent {
  render() {
    let {
      value,
      onChange,
      className,
      readOnly,
      disabled,
      placeholder = I18n.t("papp.components.TagsInputFormControl.placeholder"),
      noResultsMessage = I18n.t("papp.components.TagsInputFormControl.no_results_message"),
      type = null,
      existingTags = [],
      allowAdditions = true,
      additionLabel = I18n.t("papp.components.TagsInputFormControl.addition_label") + " ",
      ...rest
    } = this.props;

    if (type === "ProductTag.category") {
      existingTags = AppSettings.product_category_tags || [];
      allowAdditions = false;
    }

    const options = []
      .concat((value || []).filter((tag) => typeof tag === "string").map((name) => ({ value: name, text: name })))
      .concat(existingTags.map((tag) => ({ value: tag.id, text: tag.name })));

    return (
      <Dropdown
        search
        selection
        multiple
        {...rest}
        value={value === null ? [] : value}
        onAddItem={onChange && ((e, data) => onChange((value || []).concat(data.value)))}
        onChange={onChange && ((e, data) => onChange(data.value))}
        placeholder={placeholder}
        disabled={readOnly || disabled}
        className={`${className || ""} ${readOnly ? "readOnly" : ""}`}
        options={options}
        allowAdditions={allowAdditions}
        additionLabel={additionLabel}
        noResultsMessage={noResultsMessage}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/TagsInput.jsx